import { User } from '../models/user.model';

export class StoreUser {
  static readonly type = '[USER] Store';
  constructor(public payload: User) {}
}

export class DestroyUser {
  static readonly type = '[USER] Destroy';
  constructor(public payload: User) {}
}

export class GetUser {
  static readonly type = '[USER] Get';
  constructor() {}
}


